import { Component, OnInit } from '@angular/core'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { ContentService } from 'src/app/services/content/content.service'
import { FootnoteService } from 'src/app/services/footnotes/footnotes.service'

import { Footnote } from './../../../../models/footnote.model'

@Component({
  selector: 'footnotes',
  templateUrl: './footnotes.component.html',
  styleUrls: ['./footnotes.component.scss'],
})
export class FootnotesComponent implements OnInit {
  footnotes: Array<Footnote>
  sections: string[]
  sectionsMap = {
    dashboard: 'Dashboard',
    overview: 'Overview',
    performance: 'Performance & fees',
    price: 'Price',
    portfolio: 'Portfolio composition',
    distribution: 'Distribution',
    'fund-management': 'Fund management',
    'fund-literature': 'Fund literature',
  }
  constructor(
    private readonly footnoteService: FootnoteService,
    private readonly contentService: ContentService,
    private readonly centralContentService: CentralContentService,
  ) {}

  ngOnInit() {
    this.footnoteService.footnotes$.subscribe((footnotes) => {
      this.footnotes = footnotes
      this.mapToSections(footnotes)
      this.footnotes.forEach((footnote) => {
        if (footnote.text !== undefined) {
          footnote.text = this.centralContentService.formatLink(footnote.text)
        }
      })
    })
  }

  /* istanbul ignore next */
  mapToSections(footnotes) {
    const sections: string[] = []
    for (const value of footnotes) {
      if (sections.indexOf(value.section) < 0) {
        sections.push(value.section)
      }
    }
    this.sections = sections
  }
}
